import React, { Fragment, useState } from 'react';
import styles from './Warning.module.sass'

const Warning = ({ overridingAttributes, jobId }) => {
  const renderLine = (attribute, values) => {
    return (
      <tr>
        <td>
          {attribute}
        </td>

        <td>
          {values[0]}
        </td>

        <td>
          {values[1]}
        </td>
      </tr>
    )
  }

  return (
    <div>
      <p>
        This record was saved while you were editing, and you may be overwriting existing data.
      </p>

      <p>
        Please verify your changes below.
      </p>

      <hr />

      <table className={styles.table}>
        <thead>
          <tr>
            <td>
              Attribute
            </td>
            <td>
              Current value
            </td>
            <td>
              Your value
            </td>
          </tr>
        </thead>

        <tbody>
          {Object.entries(overridingAttributes).map(([attribute, values]) => renderLine(attribute, values))}
        </tbody>
      </table>

      <hr />
    </div>
  )
}

export default Warning;
